<template>
  <div>
    <v-card
      class="mx-auto my-2 pa-6 body-2"
      :style="
        $vuetify.theme.dark
          ? 'color: rgba(255,255,255,0.7);'
          : 'color: rgba(0,0,0,0.7);'
      "
    >
      <div class="mb-4">
        <h1>
          {{ $t("mainEvents") }}
        </h1>
      </div>
      {{ $t("mainEventsWhere") }}
      <br />
      {{ $t("mainEventsFinalUserSees") }}

      <br />
      {{ $t("mainEventsYouCanAddHere") }}
      <a @click.prevent="$router.push({ path: '/administrator/events/list' })">
        {{ $t("events") }}</a
      >.
    </v-card>

    <v-card>
      <div class="pa-2 d-print-none">
        <v-row no-gutters class="align-center">
          <v-spacer />
          <v-col
            cols="12"
            class="d-flex flex-row-reverse d-md-none d-lg-none d-xl-none"
          >
            <div>
              <v-btn-toggle dense>
                <v-btn @click="breakpoint = 0" ref="desktopBreakpoint">
                  <v-icon>mdi-view-list</v-icon>
                </v-btn>

                <v-btn @click="breakpoint = 'xs'" ref="mobileBreakpoint">
                  <v-icon>mdi-view-grid</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>
          </v-col>
          <v-spacer />
          <v-col cols="12" md="3">
            <v-text-field
              :class="
                $vuetify.breakpoint.smAndDown ? 'mt-3 align-self-end' : ''
              "
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              dense
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <v-divider></v-divider>
      <v-data-table
        :loading="loading"
        :loading-text="loadingText"
        :headers="headers"
        :items="items"
        :search="search"
        :items-per-page="10"
        :mobile-breakpoint="breakpoint"
        :footer-props="{
          'items-per-page-text': this.$t('rowsPerPage'),
        }"
      >
        <template v-slot:item.id_event="{ item }">
          <v-btn @click="$copy(item.id_event)" x-small>
            {{ item.id_event }}
          </v-btn>
        </template>

        <template v-slot:item.active="{ item }">
          <v-chip :color="item.active.color" outlined small>
            {{ item.active.text }}
          </v-chip>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                :disabled="loading"
                :title="getRemoveMainEventText()"
                @click="removeMainEvent(item)"
              >
                <v-icon size="24">
                  mdi-heart
                </v-icon>
              </v-btn>
            </template>
            <span>
              {{ getRemoveMainEventText() }}
            </span>
          </v-tooltip>
        </template>

        <template v-slot:no-data>
          {{ $t("noMainEvents") }}
          <a
            @click.prevent="
              $router.push({ path: '/administrator/events/list' })
            "
          >
            {{ $t("events") }}
          </a>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "AdministratorMainEvents",

  data: () => ({
    currentStatus: 0,

    items: [],
    search: "",
    breakpoint: 0,
    loading: false,

    colors: {
      1: "green darken-4",
      2: "green accent-4",
      9: "green darken-1",
      4: "red darken-1",
      7: "red lighten-2",
      5: "purple darken-1",
      3: "amber accent-4",
      6: "amber darken-1",
    },
  }),

  created() {
    this.$nextTick(() => {
      const ref = this.$vuetify.breakpoint.mobile
        ? "mobileBreakpoint"
        : "desktopBreakpoint";

      this.$refs[ref].$el.click();
    });

    this.fetchMainEvents();
  },

  computed: {
    statusItems() {
      return [
        { text: this.$t("all"), value: 0, color: this.colors[0] },
        { text: this.$t("actives"), value: 1, color: this.colors[1] },
        { text: this.$t("canceled"), value: 2, color: this.colors[2] },
        { text: this.$t("postponed"), value: 3, color: this.colors[3] },
        { text: this.$t("suspended"), value: 4, color: this.colors[4] },
      ];
    },
    headers() {
      return [
        { text: "Id", value: "id_event" },
        { text: this.$t("country"), value: "country_name" },
        { text: this.$t("sport"), value: "name_sport" },
        { text: this.$t("event"), value: "teams" },
        { text: this.$t("tournament"), value: "league_name" },
        { text: this.$t("dateTime"), value: "event_start_date" },
        { text: this.$t("status"), value: "active", align: "center" },
        {
          text: this.$t("actions"),
          value: "actions",
          align: "center d-print-none",
        },
      ];
    },
    loadingText() {
      return this.$t("loadingEvents");
    },
  },

  watch: {
    currentStatus() {
      this.fetchMainEvents();
    },
  },

  methods: {
    fetchMainEvents() {
      this.loading = true;
      this.items = [];

      this.$axios
        .get("/administrator/events/listMainEvents")
        .then((res) => {
          const events = res.data.dados;

          events.forEach((item) => {
            item.active = {
              status: item.event_status,
              text: this.$legends.eventsActive(item.event_status),
              color: this.colors[item.event_status],
            };

            item.event_start_date = new Date(
              item.event_start_date.replace(" ", "T")
            ).toLocaleString();
          });

          this.items = events;
        })
        .catch(() => {
          this.items = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    setStatusMobile(value) {
      this.currentStatus = value;
    },

    removeMainEvent(event) {
      this.loading = true;

      this.$axios
        .post(
          "/administrator/events/removeMainEvent",
          this.$formdata({ id_event: event.id_event })
        )
        .then((res) => {
          this.items = this.items.filter(({ id_main_event }) => {
            return id_main_event != event.id_main_event;
          });

          this.$store.commit("setFeedbackSnack", {
            msg: res.data.messages,
            color: "success",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getRemoveMainEventText() {
      return this.$t("removeMainEvent");
    },
  },
};
</script>
